// export const getModalCartSelector = state => state.modal.cartOpen;
export const getModalAuthRegSelector = state => state.modal.authRegOpen;
export const getModalPopupSelector = state => state.modal.popup;
export const getModalOrderSelector = state => state.modal.order;